import qs from 'qs'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinTagObjectBrowse = {
  async apiDefaultFile(arg = { method: {}, params: {} }) {
    let [err, res] = [null, null]
    const projectObj = {
      id: ' ',
    }
    if (arg.params) {
      _.assign(projectObj, arg.params)
    }
    ;[err, res] = await To(wizStandardInstance.get(`/file/getfilecontentasync/${projectObj.id}`))
    return Callback.globalCBForOld(err, res, arg.extra)
  },
  async apiTags(arg = { method: {}, params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'list':
        const listObj = {
          id: ' ',
          pageIndex: '',
          pageSize: '',
          standardId: '',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/Tag/tag-obj-data?${qs.stringify(listObj)}`)
        )
        break
      case 'docRelationFile':
        const docRelationFileObj = {
          id: ' ',
          standardId: '',
        }
        if (arg.params) {
          _.assign(docRelationFileObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/std/Tag/associated-files?${qs.stringify(docRelationFileObj)}`)
          )
        )
        break
      case 'docRelationTag':
        const docRelationTagObj = {
          id: ' ',
          standardId: '',
        }
        if (arg.params) {
          _.assign(docRelationTagObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/std/Tag/associated?${qs.stringify(docRelationTagObj)}`)
          )
        )
        break
      case 'interactiveFile':
        const interactiveFileObj = {
          siteId: ' ',
          tagCode: ' ',
          fileId: ' ',
        }
        if (arg.params) {
          _.assign(interactiveFileObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post('/api/tag/GetTagObjDataByCodeAsync', interactiveFileObj)
        )
        break
      case 'time':
        const timeObj = { tagId: ' ' }
        if (arg.params) {
          _.assign(timeObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/Tag/edit-records/${timeObj.tagId}`)
        )
        break
      case 'diff':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/std/Tag/different/${arg.params.tagId}?batchNo=${arg.params.batchNo}&compareMethod=${arg.params.compareMethod}`
          )
        )
        break
      case 'tagIdentifier':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/Tag/GetIdentifier/${arg.params.tagId}/${arg.params.fileId}`)
          )
        )
        break
      default:
        const projectObj = { id: ' ' }
        if (arg.params) {
          _.assign(projectObj, arg.params)
        }
        ;[err, res] = await To(wizStandardInstance.get(`/api/std/Tag/relations/${projectObj.id}`))
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinTagObjectBrowse,
}
